import React from 'react';
import Container from '../../../containers/master/courses/editCourseContainer';

export default function () {
  return (
    <Container />
  );
}
